import { TotalProgressionBox } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/TotalProgressionBox";
import { StretchProgressCard } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/StretchProgressCard";
import {
  AltTransBusCoverage,
  AltTransStretchCoverage,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { Field, Grid, HStack, tokens } from "shared/components/Spor";
import { Nullish } from "shared/utils/objectUtils";

interface ProgressionBodyProps {
  showAllStretches: boolean;
  stretch: AltTransStretchCoverage | null;
  setStretch: (stretch: AltTransStretchCoverage | null) => void;
  allStretchCoverages: AltTransStretchCoverage[];
  totalCoverage: Nullish<AltTransBusCoverage>;
  totalPassengersRequiringTransport: Nullish<number>;
}

export const ProgressionBody = ({
  showAllStretches,
  stretch,
  setStretch,
  allStretchCoverages,
  totalCoverage,
  totalPassengersRequiringTransport,
}: ProgressionBodyProps) => {
  const displayedStretches = showAllStretches
    ? allStretchCoverages
    : allStretchCoverages.slice(0, 3);

  return (
    <HStack gap="3" mt="2" width="100%" alignItems="flex-start">
      {totalCoverage && (
        <TotalProgressionBox
          totalCoverage={totalCoverage}
          totalPassengersRequiringTransport={totalPassengersRequiringTransport}
        />
      )}

      <Field>
        <Grid
          gap={tokens.default.size.spacing[1.5]}
          minWidth="360px"
          mt={tokens.default.size.spacing[5]}
          pt={tokens.default.size.spacing[1]}
        >
          {displayedStretches.map((card, index) => (
            <StretchProgressCard
              // eslint-disable-next-line react/no-array-index-key -- No better alternative
              key={index}
              stretchCoverage={card}
              selectedStretch={stretch}
              setStretch={setStretch}
            />
          ))}
        </Grid>
      </Field>
    </HStack>
  );
};
